<template>
  <div class="user-details">
    <h1>User Details</h1>
    <div class="button-group">
      <button @click="showUserInfo = true" :class="{ active: showUserInfo }">User Info</button>
      <button @click="showUserInfo = false" :class="{ active: !showUserInfo }">User Images</button>
    </div>

    <div v-if="showUserInfo" class="user-info">
      <h2>Personal Information</h2>
      <div class="info-block">
        <p><strong>Age:</strong> {{ user?.age || 'N/A' }}</p>
        <p><strong>Gender:</strong> {{ user?.gender || 'N/A' }}</p>
        <p><strong>Heritage Familiarity:</strong> {{ user?.heritageFamiliarity || 'N/A' }}</p>
        <p><strong>Preferred Experiences:</strong> {{ user?.preferredExperiences?.join(', ') || 'N/A' }}</p>
        <p><strong>Cultural Participation:</strong> {{ user?.culturalParticipation || 'N/A' }}</p>
        <p><strong>Learning Style:</strong> {{ user?.learningStyle || 'N/A' }}</p>
        <p><strong>Challenges:</strong> {{ user?.challenges?.join(', ') || 'N/A' }}</p>
        <p><strong>Tech Familiarity:</strong> {{ user?.techFamiliarity || 'N/A' }}</p>
        <p><strong>Devices Used:</strong> {{ user?.devicesUsed?.join(', ') || 'N/A' }}</p>
        <p><strong>Health Constraints:</strong> {{ user?.healthConstraints || 'N/A' }}</p>
      </div>
    </div>

    <div v-else class="user-images">
      <h2>User Images</h2>
      <div v-if="recordings.length" class="image-list">
        <div v-for="record in recordings" :key="record._id" class="image-entry">
          <p><strong>Transcription:</strong> {{ record.transcription }}</p>
          <chart :record="record" chart-type="audio"></chart>
          <chart :record="record" chart-type="text"></chart>
          <chart :record="record" chart-type="facial"></chart>
        </div>
      </div>
      <p v-else>No images or recordings available.</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ChartComponent from "./ChartComponent.vue"; // Import the new child component

export default {
  components: {
    Chart: ChartComponent, // Register the ChartComponent
  },
  props: ["pin"],
  data() {
    return {
      user: null,
      recordings: [],
      showUserInfo: true,
    };
  },
  methods: {
    async fetchUserDetails() {
      try {
        const userResponse = await axios.get(`https://firefly-setup.athenarc.gr/user/${this.pin}`);
        this.user = userResponse.data;

        const recordingsResponse = await axios.get(`https://firefly-setup.athenarc.gr/recordings/${this.pin}`);
        this.recordings = recordingsResponse.data;
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    },
  },
  mounted() {
    this.fetchUserDetails();
  },
};
</script>




  <style scoped>
  .user-details {
    padding: 20px;
    font-family: Arial, sans-serif;
    max-width: 800px;
    margin: 0 auto;
  }
  
  h1 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .button-group {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  
  .button-group button {
    padding: 10px 20px;
    margin: 0 5px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background-color: #f0f0f0;
    transition: background-color 0.3s;
  }
  
  .button-group button.active {
    background-color: #007bff;
    color: white;
  }
  
  .button-group button:hover {
    background-color: #0056b3;
    color: white;
  }
  
  .user-info,
  .user-images {
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #f9f9f9;
  }
  
  .info-block p {
    margin: 10px 0;
  }
  
  .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
  
  .image-entry {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 15px;
    background-color: #fff;
    max-width: 100%;
    width: calc(50% - 20px);
  }
  
  .image-entry p {
    margin: 10px 0;
  }
  
  .sentiment-analysis ul {
    padding-left: 20px;
    list-style-type: disc;
  }
  
  .sentiment-analysis h3 {
    margin-top: 10px;
  }
  
  @media (max-width: 600px) {
    .image-entry {
      width: 100%;
    }
  }
  </style>
  